import React, { useState } from 'react';
import logo from '../../../Assets/images/Logo/logo.png';
import BgImage from '../../../Assets/images/BgImage/number_background.png';
import Preview from '../../../Assets/images/LandingPageImage/preview.png';
import BeginnersGuide from './LandingComponents/Buttons/BeginnersGuide';
import GooglePlayButton from './LandingComponents/Buttons/GoogleStoreButton';
import TutorialButton from './LandingComponents/Buttons/TutorialsButton';
import AppStoreButton from './LandingComponents/Buttons/AppleStoreButton';
import SocialLinks from './SocialLinks';
import CopyrightFooter from './CopyRightFooter';
import KnowledgeBot from './LandingComponents/KnowledgeBot/UI';
import '../../../Assets/styles/LandingStyles/Landing.css';
import '../../../Assets/styles/LandingStyles/Footer.css';
import CookieConsentLanding from './CookieBanner/CookieConsentLanding';
import { useLanguage } from '../../../Core/Translations/LanguageContext'; // Import the useLanguage hook
import { LanguageSelector } from '../../../Core/Translations/LanguageSelector'; // Import the LanguageSelector component

const DesktopLanding: React.FC = () => {
    const [showBot, setShowBot] = useState(false);
    const { t, language } = useLanguage(); // Use the language hook to get translations

    const toggleBot = () => {
        setShowBot(!showBot);
    };

    return (
        <div className="App">
            {/* HEADER */}
            <header className="header">
                <img src={logo} alt="Sudoku VS Logo" className="logo" />
                <div className="tutorial_button_container">
                    {/* The tutorial button text is now dynamic */}
                    <TutorialButton text={t.header.tutorialButton} />
                </div>
                {/* Replace the static flag with the language selector component */}
                        <LanguageSelector theme="light" dropdownDirection='down' />
            </header>
            
            {/* GRADIENT */}
            <div className="gradient" />
            
            {/* MAIN CONTENT */}
            <div className="main-container">
                <div className="left-content">
                    {/* Use translated text for heading and paragraph */}
                    <h1 className="heading">{t.hero.title}</h1>
                    <p className="paragraph">
                        <strong>{t.hero.description}</strong>
                    </p>
                    
                    <div className="buttons-container">
                        {/* Use translated text for buttons */}
                        <BeginnersGuide text={t.beginnersGuide.modalTitle} />
                        <GooglePlayButton text={t.hero.googlePlay} />
                        <AppStoreButton text={t.hero.appStore} />
                        
                        {/* Bot Toggle Button - Conditionally rendered */}
                        {language === 'en' && (
                            <button 
                                onClick={toggleBot}
                                className="bot-toggle-button"
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '25px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                    transition: 'all 0.3s ease',
                                    margin: '10px 0'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                                }}
                            >
                                🤖 {showBot ? t.hero.botButtonHide : t.hero.botButtonShow}
                            </button>
                        )}
                        
                        <div className="footer-left">
                            {/* Use translated text for footer */}
                            <p className="follow-us-text">{t.footer.followUs}</p>
                            <SocialLinks />
                            <p className="handle">{t.footer.handle}</p>
                        </div>
                    </div>
                </div>
                
                <div className="right-content">
                    <div
                        className="bg-container clip-slanted"
                        style={{ backgroundImage: `url(${BgImage})` }}
                    />
                    <div className="preview-container">
                        <img
                            src={Preview}
                            alt="Sudoku VS Preview"
                            className="preview-image"
                        />
                    </div>
                </div>
            </div>

            {/* Bot Modal/Overlay */}
            {showBot && (
                <div 
                    className="bot-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px'
                    }}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            setShowBot(false);
                        }
                    }}
                >
                    <div 
                        className="bot-container"
                        style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: '500px',
                            height: '80vh',
                            maxHeight: '700px',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowBot(false)}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'rgba(255, 255, 255, 0.9)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#666',
                                zIndex: 1001,
                                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                                e.currentTarget.style.color = '#333';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                                e.currentTarget.style.color = '#666';
                            }}
                        >
                            ×
                        </button>
                        
                        {/* Bot Component */}
                        <KnowledgeBot />
                    </div>
                </div>
            )}
            
            {/* Copyright Footer */}
            <CopyrightFooter />
            
        </div>
    );
};

export default DesktopLanding;
